/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coverapppreviewchat3Inputs */

const en_coverapppreviewchat3 = /** @type {(inputs: Coverapppreviewchat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In chat`)
};

const de_coverapppreviewchat3 = /** @type {(inputs: Coverapppreviewchat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Im Chat`)
};

/**
* | output |
* | --- |
* | "In chat" |
*
* @param {Coverapppreviewchat3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const coverapppreviewchat3 = /** @type {((inputs?: Coverapppreviewchat3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coverapppreviewchat3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coverapppreviewchat3(inputs)
	return de_coverapppreviewchat3(inputs)
});
export { coverapppreviewchat3 as "coverAppPreviewChat" }